<script>
  import axios from "axios"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import LoadingScreen from "../../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import { push, querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import BackConfirmation from "./Components/backConfirmation.svelte"
  import notify from "../../../../Script/notify"
  import { onMount } from "svelte"
  import ApplicationState from "../../../../Stores/applicationStates"
  import AuthInput from "../../../../Shared/authInput.svelte"
  import { getFileHash } from "../../../../Script/fileHash"
  import sha256 from "crypto-js/sha256"
  import { validateFile } from "../../../../Script/validateFIle.js"
  import { loadImage } from "../../../../Script/loadImage.js"
  import RegexValidatedInput from "./Components/regexValidatedInput.svelte"
  import EmailInput from "./Components/emailInput.svelte"
  import { replaceSpclCharsRegex } from "../../../../Script/regex.js"
  import { allowedSpclCharsRegex } from "../../../../Script/regex.js"
  import NormalInput from "./Components/normalInput.svelte"
  import { getRequest, postRequest } from "../../../../Script/apiMethods.js"
  import UploadArea from "./Modules/Croparea/index.svelte"

  /**
   * @typedef {Object} emptyNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {String} text displayed with the svg loader while loading
   */
  let loadingText = "Fetching Signer"

  /**
   * @type {emptyNotification}
   */
  let errorNotification = {
    close() {},
  }
  /**
   * @typedef {Object} emptyNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {emptyNotification}
   */
  let successNotification = {
    close() {},
  }

  /**
   * @type {emptyNotification}
   */
  let closeNotification = {
    close() {},
  }

  /**
   * @type {Boolean} - wether to show or not loading screen
   */
  let showLoader = false

  /**
   * @type {Boolean} - whether to show or not back confirmation model
   */
  let showBackmodal = false

  /**
   * @type {String} - uploaded sign uri
   */
  let signatureUri = ""

  /**
   * @type {Boolean} -  whether to show or not auth input model
   */
  let showAuthModal = false

  /**
   * @type {String} -  Authendication code
   */
  let code = ""

  /**
   * @type {RegExp} regex for number letters and limited spcl character
   */
  const allowedCharsRegex = /^[A-Za-z0-9\s-()+&@.,]+$/

  /**
   * @type {RegExp} regex for replacing not allowed character
   */
  const replaceInvalidCharsRegex = /[^A-Za-z0-9\s-()+&@.,]/g

  /**
   * @type {Object} Signer detsils contained object
   */
  let signerDetails = {}

  /**
   * @type {Object} stores the query value in an object
   */
  let query = {}

  let uploadedFile

  let showBackgroundRemover = false

  let showAutoEnhanced = false

  let showCropArea = false

  let blobURL = ""

  onMount(async () => {
    try {
      // Prevent execution if unauthorized (because pop() is asynchronous)
      if (!$ApplicationState.pdfEnabled || !$ApplicationState.msignToken) return

      closeNotification.close()
      query = queryStringToJSON($querystring)
      if (query.id) {
        showLoader = true

        // Fetch Signer Details
        const { signer } = await getRequest(`/api/pdf-signing/v2/internal/signers/${query.id}`, {
          headers: {
            "msign-org-token": $ApplicationState.msignToken,
          },
        })

        signerDetails = signer

        // Fetch Signature Image
        const fileData = await getRequest(`/api/pdf-signing/v2/internal/signers/signImg/${signerDetails.id}`, {
          headers: {
            "msign-org-token": $ApplicationState.msignToken,
          },
          responseType: "blob",
        })
        signerDetails.signImage = URL.createObjectURL(fileData)

        console.log({ signerDetails })
      }
    } catch (error) {
      const info = "PAGE: Add Signer\nEVENT: onMount"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
    }
  })

  // /**
  //  * @description Function for get image uri from file
  //  * @param {Object} e  file on change event details
  //  *
  //  */
  // const UploadSignature = async (e) => {
  //   try {
  //     errorNotification.close()
  //     // console.log(e.target.files[0])

  //     if (e.target.files[0].size > 153600) throw "Maximum size Exceeded. Signature Image size should be less than 150KB"

  //     await validateFile(e.target.files[0])

  //     let img = await loadImage(URL.createObjectURL(e.target.files[0]))
  //     // console.log(img)

  //     if (img.width > 596 || img.height > 205) throw "Please resize the signature image to fit the required dimensions (596 * 205) and try again."

  //     signatureUri = URL.createObjectURL(e.target.files[0])
  //   } catch (error) {
  //     e.dataTransfer ? (e.dataTransfer.value = null) : (e.target.value = null)
  //     // console.error(error)
  //     errorNotification = notify.danger(error)
  //   }
  // }

  /**
   * @description Function for form validation
   *
   */
  const formValidation = async () => {
    try {
      let form = document.getElementById("addSignerForm")
      if (!form.name.value) throw "Name should be mandatory"
      if (!form.designation.value) throw "Designation should be mandatory"
      if (!form.location.value) throw "Location should be mandatory"
      if (!form.email.value) throw "Email should be mandatory"
      if (!form.contact.value) throw "Contact should be mandatory"

      if (!uploadedFile) throw "Kindly upload image to continue"
      if (showBackgroundRemover) throw "Kindly continue to remove background or else go back and sign."
      if (showCropArea) throw "Kindly continue to crop signature or else go back and sign."
      if (showAutoEnhanced) uploadedFile = await convertBlobToFile(blobURL)

      // if (!form.signature.files[0]) throw "Signature Image should be mandatory"
    } catch (error) {
      throw error
    }
  }
  /**
   * @description Function for form validation
   *
   */
  const checkFormContainValues = () => {
    try {
      let form = document.getElementById("addSignerForm")
      if (form.name.value || form.designation.value || form.location.value || form.email.value || form.contact.value || uploadedFile) return true
      return false
    } catch (error) {
      throw error
    }
  }

  /**
   * @description Function for get add signer form data
   * @returns {Object} user filed form data returns
   */
  const getFormData = async () => {
    try {
      let form = document.getElementById("addSignerForm")
      // console.log(form.name.value)
      let formData = {}
      formData.name = form.name.value
      formData.designation = form.designation.value
      formData.location = form.location.value
      formData.email = form.email.value
      formData.contact = form.contact.value
      // formData.orgId = $ApplicationState.orgId || "TEST"
      formData.orgId = $ApplicationState.issuerID
      formData.pfx = form.pfx.value
      formData.signatureImage = showAutoEnhanced ? await convertBlobToFile(blobURL) : uploadedFile
      // formData.signatureImage = form.signature.files[0]

      // console.log({ formData })

      let fileHash = await getFileHash(formData.signatureImage)
      // let fileHash = await sha256(formData.signatureImage).toString()
      // console.log({ fileHash })

      let concatenateData = formData.name + formData.designation + formData.location + formData.email + formData.contact + formData.orgId + formData.pfx + fileHash

      // console.log({ concatenateData })

      let concatenateDataHash = sha256(concatenateData).toString()

      // console.log({ concatenateDataHash })

      formData.signature = concatenateDataHash
      return formData
    } catch (error) {
      throw error
    }
  }

  const convertBlobToFile = async (uri) => {
    try {
      const { data } = await axios.get(uri, { responseType: "blob" })

      const blobFile = new File([data], uploadedFile.name, {
        type: "image/png",
      })

      return blobFile
    } catch (error) {
      throw error
    }
  }

  /**
   * Confirm the authentication code entered by the user.
   * Extracts the code from the input fields, hides the confirmation modal, and triggers a specific function.
   * @param {Event} e - The event object, representing the form submission.
   */
  const handleSignerCreation = async (e) => {
    try {
      loadingText = "Adding signer"
      closeNotification.close()
      showAuthModal = false
      showLoader = true

      let target = e.detail.target

      // Extract the authentication code from the input fields
      code = target[0].value + target[1].value + target[2].value + target[3].value + target[4].value + target[5].value
      let formdata = await getFormData()
      // console.log({ formdata })

      //  Verify Auth Code
      const { signProxyPass } = await postRequest(
        `/api/swagger/v2/misc/proxy-sign`,
        {
          otp: code,
        },
        {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        }
      )
      // console.log({ signProxyPass })

      // Signature Generation
      const { signature } = await postRequest(
        `/api/swagger/v2/misc/proxy-sign`,
        {
          signProxyPass,
          msg: formdata.signature,
        },
        {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        }
      )
      // console.log({ signature })

      formdata.signature = signature

      // Create Signer
      await postRequest("/api/pdf-signing/v2/internal/signers", formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          "msign-org-token": $ApplicationState.msignToken,
        },
      })

      notify.success("Signer Created successfully.")

      push(`/signing/signer`)
    } catch (error) {
      // console.error(error)
      code = ""
      const info = "PAGE: Add Signer\nEVENT: Error occurred while creating signer."
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
      // console.log({ showLoader })
    }
  }

  const validateDetails = async () => {
    try {
      errorNotification.close()

      await formValidation()
      showAuthModal = true
    } catch (error) {
      const info = "PAGE: Add Signer\nEVENT: Error occurred while validating signer details before creation."
      errorNotification = notify.danger(error, info)
    }
  }
</script>

<svelte:head>
  <title>Add Signer</title>
</svelte:head>

{#if showLoader}
  <LoadingScreen msg={loadingText} />
{/if}

{#if showBackmodal}
  <BackConfirmation
    on:cancel={() => {
      showBackmodal = false
    }}
    on:dontSave={() => {
      showBackmodal = false
      push("/signing/signer")
    }}
    on:click={async () => {
      try {
        errorNotification.close()
        successNotification.close()
        await formValidation()
        let data = await getFormData()
        console.log(data)
        showAuthModal = true
      } catch (error) {
        const info = "PAGE: Add Signer\nEVENT: Error occurred while submitting signer details by save option in back modal."
        errorNotification = notify.danger(error, info)
        console.error(error)
      } finally {
        showBackmodal = false
      }
    }}
  />
{/if}

{#if showAuthModal}
  <div class="fixed inset-0 -top-3 z-50 mt-0 flex flex-col items-center justify-center gap-3 overflow-hidden bg-[#000000cc] backdrop-blur-md">
    <div class="relative m-6 transform select-none rounded-md bg-white text-left transition-all dark:bg-bodyblack md:m-0 md:w-[700px]">
      <div class="flex w-full items-center justify-center rounded-md bg-white p-3 pb-0 text-black dark:bg-bodyblack md:px-6 md:pt-6">
        <h1 class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Signer Creation</h1>
      </div>

      <div class="px-3 py-3">
        <!-- svelte-ignore missing-declaration -->
        <AuthInput bind:code on:submit={handleSignerCreation} cancelBtn={true} on:click={() => (showAuthModal = false)} title="Please enter an Authentication Code from the linked Authenticator App to confirm the creation of the Signer. " />
      </div>
    </div>
  </div>
{/if}

<div class="relative min-h-screen w-full overflow-x-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6">
    <div class="mx-auto h-auto w-full max-w-[920px] pb-40 pt-6">
      <div class="mx-auto w-full">
        <button
          type="button"
          on:click={() => {
            if (!query.id && checkFormContainValues()) showBackmodal = true
            else push(`/signing/signer`)
          }}
          style="text-decoration: none;"
          class="mb-1 flex w-16 cursor-pointer select-none items-center gap-2 whitespace-nowrap text-base font-medium text-gray-200 hover:text-blue-600 focus-visible:text-blue-600 focus-visible:outline-none active:text-blue-500 sm:mb-0"
        >
          <i class="fa-solid fa-reply" />
          <span>Back</span>
        </button>

        <div class="flex justify-between">
          <div class="flex flex-col items-center justify-center mobile:mt-0 md:ml-0 md:items-start">
            <div class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">{!query.id ? "Add Signer" : "Signer Details"}</div>
          </div>

          {#if !query.id}
            <div class="mt-3 flex items-center justify-center gap-3 md:mt-0">
              <button on:click={validateDetails} type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-[#f7f7f7]/50 disabled:text-gray-900/50 dark:bg-green-500 dark:text-white dark:hover:bg-green-600 sm:w-auto">
                <span>
                  <i class="fa-solid fa-user-plus" />
                </span>
                <span class="select-none">&nbsp;&nbsp;Create&nbsp;Signer</span>
              </button>
            </div>
          {/if}
        </div>
      </div>
      <div class="relative mt-3 flex min-h-[470px] flex-col justify-between gap-6 rounded-md bg-white p-6 text-white dark:bg-mdGray">
        {#if !query.id}
          <form on:submit|preventDefault|stopPropagation={validateDetails} id="addSignerForm" class="w-full space-y-3">
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              <label for="name" class="w-full text-gray-200 md:w-1/3">Name</label>
              <NormalInput inputName="name" placeholder="Enter signer name" />
            </div>
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              <label for="designation" class="w-full text-gray-200 md:w-1/3">Designation</label>
              <RegexValidatedInput placeholder="Enter signer Designation" inputName="designation" replaceRegex={replaceSpclCharsRegex} regex={allowedSpclCharsRegex} errorMsg="Only letters, numbers, and special characters -()+&@., are allowed." />
            </div>
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              <label for="location" class="w-full text-gray-200 md:w-1/3">Location</label>
              <RegexValidatedInput placeholder="Enter signer Location" inputName="location" replaceRegex={replaceSpclCharsRegex} regex={allowedSpclCharsRegex} errorMsg="Only letters, numbers, and special characters -()+&@., are allowed." />
            </div>
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              <label for="email" class="w-full text-gray-200 md:w-1/3">Email</label>
              <EmailInput placeholder="Enter signer Email" inputName="email" />
            </div>
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              <label for="contact" class="w-full text-gray-200 md:w-1/3">Contact</label>
              <input
                on:keypress={(e) => {
                  if (e.key == "e" || e.key == "E" || e.key == "-" || e.key == "+" || e.key == ".") e.preventDefault()
                }}
                required
                autocomplete="off"
                type="number"
                name="contact"
                id="contact"
                placeholder="Enter signer contact"
                class="w-full rounded-md border border-[#a0a1a580] bg-white py-2 pl-3 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:bg-transparent dark:text-white dark:placeholder:text-gray-200 sm:pr-9 sm:text-sm md:w-2/3"
              />
            </div>
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              <div class="flex w-full items-center gap-3 text-gray-200 md:w-1/3">
                <label for="pfx">PFX file name</label>
                <div data-tooltip="File name for PFX provided by Print2Block" tooltip-position="top">
                  <i class="fa-solid fa-circle-info" />
                </div>
              </div>
              <input value="DEFAULT" type="text" name="pfx" id="pfx" placeholder="Give a organitation pfx file" readonly class="w-full rounded-md border border-[#a0a1a580] bg-white py-2 pl-3 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:bg-transparent dark:text-white dark:placeholder:text-gray-200 sm:pr-9 sm:text-sm md:w-2/3" />
            </div>
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              {#if !signatureUri}
                <label for="signature" class="w-full text-gray-200 md:w-1/3">Upload a signature image</label>
              {:else}
                <p class="w-full text-gray-200 md:w-1/3">Upload a signature image</p>
              {/if}
              <div class="min-h-40 w-full md:w-2/3">
                <UploadArea bind:blobURL bind:uploadedFile bind:showBackgroundRemover bind:showCropArea bind:showAutoEnhanced />

                <!-- <div class:hidden={signatureUri} class="relative flex h-full w-full flex-col items-center justify-center gap-3 rounded-md border border-dashed border-gray-200 p-3 hover:border-gray-200/50 hover:bg-[#f7f7f7] hover:dark:bg-bodyblack">
                  <input on:input={UploadSignature} name="signature" id="signature" type="file" accept=".png, .jpg, .jpeg" class="absolute inset-0 cursor-pointer opacity-0" />
                  <div class=" text-xl text-blue-500 lg:text-3xl">
                    <i class="fa-solid fa-cloud-arrow-up" />
                  </div>
                  <p class="md:txet-base select-none text-center text-sm font-medium text-gray-200">Select a file by dragging and dropping it, or Click here to upload</p>
                  <p class="select-none text-center text-xs font-normal text-gray-100 md:text-sm">Maximum Size 150KB</p>
                  <p class="select-none text-center text-xs font-normal text-gray-100 md:text-sm">Maximum dimension 596 * 205</p>
                  <p class="select-none text-center text-xs font-normal text-blue-500 md:text-sm">Supported formats: .png, .jpg, .jpeg only.</p>
                </div>
                <div class:hidden={!signatureUri} class="flex h-full w-fit items-center">
                  <div class="group relative h-auto overflow-hidden rounded-md">
                    <button
                      on:click={() => {
                        let form = document.getElementById("addSignerForm")
                        form.signature.value = null
                        signatureUri = ""
                      }}
                      type="button"
                      class="absolute right-3 top-3 flex text-red-500 group-hover:text-red-600"
                    >
                      <i class="fa-solid fa-circle-xmark" />
                    </button>
                    <img src={signatureUri} class="aspect-auto h-auto max-h-40" alt="signatory image" />
                  </div>
                </div> -->
              </div>
            </div>
            <div class="flex justify-end">
              <button type="submit" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-[#f7f7f7]/50 disabled:text-gray-900/50 dark:bg-green-500 dark:text-white dark:hover:bg-green-600 sm:w-auto">
                <span>
                  <i class="fa-solid fa-user-plus" />
                </span>
                <span class="select-none">&nbsp;&nbsp;Create&nbsp;Signer</span>
              </button>
            </div>
          </form>
        {:else}
          <div class="w-full space-y-3">
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              <label for="name" class="w-full text-gray-200 md:w-1/3">Name</label>
              <div class="w-full truncate rounded-md bg-[#f7f7f7] py-2 pl-3 text-sm text-black dark:bg-bodyblack dark:text-white sm:text-sm md:w-2/3">{signerDetails.name}</div>
            </div>
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              <label for="designation" class="w-full text-gray-200 md:w-1/3">Designation</label>
              <div class="w-full truncate rounded-md bg-[#f7f7f7] py-2 pl-3 text-sm text-black dark:bg-bodyblack dark:text-white sm:text-sm md:w-2/3">{signerDetails.designation}</div>
            </div>
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              <label for="location" class="w-full text-gray-200 md:w-1/3">Location</label>
              <div class="w-full truncate rounded-md bg-[#f7f7f7] py-2 pl-3 text-sm text-black dark:bg-bodyblack dark:text-white sm:text-sm md:w-2/3">{signerDetails.location}</div>
            </div>
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              <label for="email" class="w-full text-gray-200 md:w-1/3">Email</label>
              <div class="w-full truncate rounded-md bg-[#f7f7f7] py-2 pl-3 text-sm text-black dark:bg-bodyblack dark:text-white sm:text-sm md:w-2/3">{signerDetails.email}</div>
            </div>
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              <label for="contact" class="w-full text-gray-200 md:w-1/3">Contact</label>
              <div class="w-full truncate rounded-md bg-[#f7f7f7] py-2 pl-3 text-sm text-black dark:bg-bodyblack dark:text-white sm:text-sm md:w-2/3">{signerDetails.contact}</div>
            </div>
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row md:items-center">
              <div class="flex w-full items-center gap-3 text-gray-200 md:w-1/3">
                <label for="pfx">PFX file name</label>
                <div data-tooltip="File name for PFX provided by Print2Block" tooltip-position="top">
                  <i class="fa-solid fa-circle-info" />
                </div>
              </div>
              <div class="w-full rounded-md bg-[#f7f7f7] py-2 pl-3 text-sm text-black dark:bg-bodyblack dark:text-white sm:text-sm md:w-2/3">{signerDetails.org}</div>
            </div>
            <div class="flex w-full flex-col justify-between gap-1 md:flex-row">
              <label for="contact" class="w-full text-gray-200 md:w-1/3">Signature Image</label>
              <div class="h-full max-h-[250px] w-full md:w-2/3">
                <img src={signerDetails.signImage} alt="SignImage" class="imageHeight aspect-auto" />
              </div>
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>

  <Footer />
</div>

<style>
  .imageHeight {
    max-height: inherit;
  }
</style>
